export enum ComposeSnapshotSyncBlockedReason {
  CONFLICT = 'CONFLICT',
  NOT_FOUND = 'NOT_FOUND',
  PAYLOAD_TOO_LARGE = 'PAYLOAD_TOO_LARGE',
}
